import { render, staticRenderFns } from "./DhmeAssemblyHallDashboardLinkTactDialog.vue?vue&type=template&id=58be0192&scoped=true"
import script from "./DhmeAssemblyHallDashboardLinkTactDialog.vue?vue&type=script&lang=js"
export * from "./DhmeAssemblyHallDashboardLinkTactDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58be0192",
  null
  
)

export default component.exports